import { useState, useEffect } from 'react';
import { CommissionSliderContainer, SliderContent } from './style';

const getMarks = (minGrievancePercent, maxGrievancePercent) => {
  const marks = [
    { value: minGrievancePercent, label: `${minGrievancePercent}%` },
    { value: maxGrievancePercent, label: `${maxGrievancePercent}%` },
  ];

  if (minGrievancePercent < 0 && maxGrievancePercent > 0) {
    marks.splice(1, 0, { value: 0, label: '0%' });
  }

  return marks;
};

const ComissionSlider = ({
  setPercentCommission,
  grievance_percent,
  min_grievance_percent,
  percentCommission,
  useRangeSlider,
}) => {
  const minGrievancePercent = Number(min_grievance_percent ?? 0);
  const maxGrievancePercent = Number(grievance_percent ?? 0);
  const sliderMin = useRangeSlider ? minGrievancePercent : 0;
  const sliderMax = useRangeSlider ? maxGrievancePercent : 100;
  const shouldShowSlider = useRangeSlider ? minGrievancePercent !== maxGrievancePercent : maxGrievancePercent !== 0;
  const [percentCommissionLocal, setPercentCommissionLocal] = useState(percentCommission);

  useEffect(() => {
    setPercentCommissionLocal(percentCommission);
  }, [percentCommission]);

  return (
    <CommissionSliderContainer style={{ padding: 30 }}>
      {shouldShowSlider && (
        <>
          <p>Percentual de comissionamento</p>
          <SliderContent
            track={false}
            aria-labelledby="track-false-slider"
            valueLabelDisplay="auto"
            valueLabelFormat={(e) => {
              if (useRangeSlider) return `${e}%`;

              return `${Math.round((percentCommissionLocal * maxGrievancePercent) / 100)}%`;
            }}
            getAriaValueText={(value) => `${value}`}
            defaultValue={sliderMin}
            value={percentCommissionLocal}
            onChange={(event) => {
              setPercentCommissionLocal(event.target.value);
            }}
            onChangeCommitted={(event, value) => {
              setPercentCommission(value);
            }}
            min={sliderMin}
            max={sliderMax}
            step={1}
            marks={
              useRangeSlider
                ? getMarks(minGrievancePercent, maxGrievancePercent)
                : [
                    { value: 0, label: '0%' },
                    { value: 100, label: `${maxGrievancePercent}%` },
                  ]
            }
          />
        </>
      )}
    </CommissionSliderContainer>
  );
};

export default ComissionSlider;
